<h2  >Conocenos</h2>
<p style="display: flex;">
    <iframe width="700" height="400" [src]="getVideoIframe(linkCode)" frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</p>